import React, { useLayoutEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { Outlet, useOutletContext } from 'react-router-dom';

import { injectIntl } from 'react-intl';

import * as globalActions from '@redux/global/actions';
import roleReducer from './controllers/reducer';
import roleSaga from './controllers/saga';
import * as roleActions from './controllers/actions';

import { useInjectSaga } from 'utils/common/injectSaga';
import { useInjectReducer } from 'utils/common/injectedReducers';

import { createSuspenseRoute, SECURE_CONFIG } from 'utils/SecureRoute';

import RoleManagement from 'pages/role/view/role-management';
const { lazy } = React;

// const RoleManagement = lazy(() => import('./view/role-management'));

// const RoleManagement = lazy(() => import('./view/role-management'));
const RoleEdit = lazy(() => import('./view/role-edit'));
const MemberRoleMatrix = lazy(() => import('./view/member-role-matrix'));
const RequestGrid = lazy(() => import('pages/security-request/RequestGrid'));

const key = 'role';

const RoleManagementWrapper = (props) => {
  const { refEnableAutoScroll } = useOutletContext();
  return (
    <RoleManagement {...props} refEnableAutoScroll={refEnableAutoScroll} />
  );
};

const RoleEditWrapper = (props) => {
  const { refEnableAutoScroll } = useOutletContext();
  return <RoleEdit {...props} refEnableAutoScroll={refEnableAutoScroll} />;
};

const MemberRoleMatrixWrapper = (props) => {
  const { refEnableAutoScroll } = useOutletContext();
  return (
    <MemberRoleMatrix {...props} refEnableAutoScroll={refEnableAutoScroll} />
  );
};

// Routes that will be nested under /security
export const securityNestedRoutes = [
  {
    index: true,
    element: createSuspenseRoute({
      secureConfig: SECURE_CONFIG.EDIT_USER_PERMISSION,
      Component: RoleManagementWrapper,
    }),
  },
  {
    path: 'member/:memberId',
    element: createSuspenseRoute({
      secureConfig: SECURE_CONFIG.EDIT_USER_PERMISSION,
      Component: RoleManagementWrapper,
    }),
  },
  {
    path: 'role/:roleId/member/:memberId/edit',
    element: createSuspenseRoute({
      secureConfig: SECURE_CONFIG.EDIT_USER_PERMISSION,
      Component: RoleEditWrapper,
    }),
  },
  {
    path: 'role/:roleId/edit',
    element: createSuspenseRoute({
      secureConfig: SECURE_CONFIG.EDIT_USER_PERMISSION,
      Component: RoleEditWrapper,
    }),
  },
];

// Routes that will be nested under /security-matrix
export const securityMatrixNestedRoutes = [
  {
    index: true,
    path: 'member-role',
    element: createSuspenseRoute({
      secureConfig: SECURE_CONFIG.MANAGE_MEMBER_ROLE,
      Component: MemberRoleMatrixWrapper,
    }),
  },
  {
    path: 'permission-request',
    element: createSuspenseRoute({
      secureConfig: SECURE_CONFIG.MANAGE_MEMBER_ROLE,
      Component: RequestGrid,
    }),
  },
];

const Role = () => {
  useInjectReducer({ key, reducer: roleReducer });
  useInjectSaga({ key, saga: roleSaga });

  const dispatch = useDispatch();

  const refEnableAutoScroll = useRef(null);

  useLayoutEffect(() => {
    dispatch(roleActions.getAvailablePermissions());
    return () => {
      dispatch(roleActions.clearRoleState());
    };
  }, [dispatch]);

  return <Outlet context={{ refEnableAutoScroll }} />;
};

export default injectIntl(Role);
